import { BaseService } from '../base';
class HelpInformationService extends BaseService {
    constructor() {
        super('/settings/help');
    }
    // TODO: Make use of the generic methods from the base service
    async getHelpInformation() {
        const response = await this.httpClient.get('/settings/help');
        return response.data;
    }
    async getHelpInformationByDivId(divId) {
        const response = await this.httpClient.get('/settings/help/divId/' + divId);
        return response.data;
    }
    async getHelpInformationId(id) {
        const response = await this.httpClient.get('/settings/help/' + id);
        return response.data;
    }
    async createHelpInformation(payload) {
        const response = await this.httpClient.post('/settings/help', payload);
        return response.data;
    }
    async updateHelpInformation(id, payload) {
        const response = await this.httpClient.patch('/settings/help/' + id, payload);
        return response.data;
    }
    async deleteHelpInformation(id) {
        const response = await this.httpClient.delete('/settings/help/' + id);
        return response.data;
    }
}
export default HelpInformationService;
